export enum DownloadType {
	CALLS = 'calls',
	TEXTS = 'texts',
	VOICEMAILS = 'voicemails',
}

export enum MutationStatus {
	IDLE = 'idle',
	PENDING = 'pending',
	SUCCESS = 'success',
	ERROR = 'error',
}

export enum FilterStatus {
	ALL = 'all',
}
